import {
  Box,
  Slider as MuiSlider,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from '@mui/material';
import { useForm } from './Context';

export default function Slider({
  id,
  label,
  fullWidth,
  defaultValue,
  required,
  min = 0,
  max = 100,
  onChange,
}) {
  const { readonly, error, value, handleChange } = useForm(id, defaultValue);

  return (
    <Box mx={3} my={2}>
      <FormControl error={error} fullWidth={fullWidth}>
        <FormControlLabel label={label} control={<></>} />

        <MuiSlider
          value={typeof value === 'number' ? value : 0}
          disabled={readonly}
          onChange={(event, newValue) => {
            handleChange(event, newValue);
            if (onChange) onChange(event, newValue);
          }}
          required={required}
          min={min}
          max={max}
          valueLabelDisplay="auto"
        />

        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </Box>
  );
}
